import { cleanObject } from "../helpers";
import axiosInstance from "./baseUrl";

// Get pending approval products
export const fetchPendingProducts = async (params?: any) => {
  const response = await axiosInstance.get(`/v1/product/pending-approval`, {
    params: cleanObject(params),
  });
  return response.data;
};
// Get all approval products
export const fetchAllProducts = async (params?: any) => {
  const response = await axiosInstance.get(`/v1/product/admin_list_products`, {
    params: cleanObject(params),
  });
  return response.data;
};
// Get approved products
export const fetchApprovedProducts = async (params?: any) => {
  const response = await axiosInstance.get(`/v1/product/approved`, {
    params: cleanObject(params),
  });
  return response.data;
};

// Get rejected products
export const fetchRejectedProducts = async (params?: any) => {
  const response = await axiosInstance.get(`/v1/product/rejected`, {
    params: cleanObject(params),
  });
  return response.data;
};

// Get product stats
export const fetchProductStats = async () => {
  const response = await axiosInstance.get(`/v1/product/stats`);
  return response.data;
};
// Get product categories
export const fetchCategories = async () => {
  const response = await axiosInstance.get(`/v1/category/list_category`);
  return response.data;
};
// Get size charts
export const fetchSizeCharts = async (params?: any) => {
  const response = await axiosInstance.get(`/v1/size/charts`, {
    params: cleanObject(params),
  });
  return response.data;
};

// Approve a product
export const approveProduct = async (payload: {
  productId: string;
  approvalStatus: string;
  rejectionReason?: string;
}) => {
  const response = await axiosInstance.post(
    `/v1/product/approve`,
    cleanObject(payload)
  );
  return response.data;
};
// Approve a product
export const updateProductCategory = async (payload: {
  id: string;
  categoryIds: string;
}) => {
  const formData = new FormData();
  formData.append("categoryIds", payload.categoryIds);

  const response = await axiosInstance.put(
    `/v1/product/admin/update_product/${payload.id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

// Approve a product
export const updateProductDetails = async (id: string, updatedData: any) => {
  const formData = cleanObject({
    name: updatedData.name,
    description: updatedData.description,
    price: updatedData.price,
    quantity: updatedData.quantity,
    colors: updatedData.colors,
    sizeChartId: updatedData.sizeChartId,
    tags: updatedData.tags,
    sizes: updatedData.sizes,
  });

  const response = await axiosInstance.put(
    `/v1/product/admin/update_product/${id}`,
    formData
  );

  return response.data;
};
